import { render, staticRenderFns } from "./TournamentSchedule.vue?vue&type=template&id=37968bda&"
import script from "./TournamentSchedule.vue?vue&type=script&lang=js&"
export * from "./TournamentSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TournamentSchedule.vue?vue&type=style&index=0&id=37968bda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports